/**
 * Cooling system create/update payload helpers (#996 Phase 2).
 */

import type { LargeUpsConfiguration } from '../types/largeUps';

/** Strip server metadata before POST /requests/:id/large-ups */
export function toCreateLargeUpsPayload(
  unit: LargeUpsConfiguration,
): Omit<LargeUpsConfiguration, 'id' | 'createdAt' | 'updatedAt'> {
  const {
    id: _id,
    createdAt: _createdAt,
    updatedAt: _updatedAt,
    ...payload
  } = unit;
  return payload;
}
